import Paper from "@mui/material/Paper"
import { sort } from "ramda"
import { AvatarBar } from "./AvatarBar"
import { byRanking } from "./byRanking"

import Stack from "@mui/material/Stack"
import { IneditableList } from "./IneditableList"
import { PageTitle } from "./lib/PageTitle"
import { ListHeader } from "./ListHeader"
import { PancakeStack } from "./PancakeStack"
import type { PollPhenomenon } from "./poll"
import { PollNavigation } from "./PollNavigation"
import { schulzeMethod } from "./schulzeMethod"
import { SyncBar } from "./SyncBar"
import { isNull, TitleField } from "./TitleField"

export function ResultsView(props: { poll: PollPhenomenon }): JSX.Element {
  const {
    poll: { title, ballots, candidates, id },
  } = props
  return (
    <>
      <PageTitle value={title ? `Results: ${title} |` : "" + "Druthers"} />
      <PancakeStack>
        <Paper>
          <Stack p={2} direction="row" spacing={1}>
            <TitleField
              value={title}
              label="Poll Title"
              placeholder=""
              variant="adorned"
            />
          </Stack>
          <SyncBar show={false} />
        </Paper>
        <div>
          <ListHeader>
            <AvatarBar poll={props.poll} />
          </ListHeader>
          <IneditableList
            isReady={!isNull(title)}
            items={sort(
              byRanking(schulzeMethod(ballots, candidates)),
              candidates,
            )}
          />
        </div>
        <PollNavigation pollID={id} nav="results" />
      </PancakeStack>
    </>
  )
}
